import { ReactNode, useState } from "react";

interface DebugBoxProps {
  title: string;
  color: "purple" | "blue" | "green" | "red" | "orange";
  children: ReactNode;
  defaultOpen?: boolean;
}

const colorClasses = {
  purple: {
    bg: "bg-purple-50 dark:bg-purple-900/20",
    border: "border-purple-200 dark:border-purple-700",
    titleText: "text-purple-800 dark:text-purple-300",
    buttonBg: "bg-purple-200 dark:bg-purple-700",
    buttonText: "text-purple-800 dark:text-purple-200",
    buttonHover: "hover:bg-purple-300 dark:hover:bg-purple-600",
  },
  blue: {
    bg: "bg-blue-50 dark:bg-blue-900/20",
    border: "border-blue-200 dark:border-blue-700",
    titleText: "text-blue-800 dark:text-blue-300",
    buttonBg: "bg-blue-200 dark:bg-blue-700",
    buttonText: "text-blue-800 dark:text-blue-200",
    buttonHover: "hover:bg-blue-300 dark:hover:bg-blue-600",
  },
  green: {
    bg: "bg-green-50 dark:bg-green-900/20",
    border: "border-green-200 dark:border-green-700",
    titleText: "text-green-800 dark:text-green-300",
    buttonBg: "bg-green-200 dark:bg-green-700",
    buttonText: "text-green-800 dark:text-green-200",
    buttonHover: "hover:bg-green-300 dark:hover:bg-green-600",
  },
  red: {
    bg: "bg-red-50 dark:bg-red-900/20",
    border: "border-red-200 dark:border-red-700",
    titleText: "text-red-800 dark:text-red-300",
    buttonBg: "bg-red-200 dark:bg-red-700",
    buttonText: "text-red-800 dark:text-red-200",
    buttonHover: "hover:bg-red-300 dark:hover:bg-red-600",
  },
  orange: {
    bg: "bg-orange-50 dark:bg-orange-900/20",
    border: "border-orange-200 dark:border-orange-700",
    titleText: "text-orange-800 dark:text-orange-300",
    buttonBg: "bg-orange-200 dark:bg-orange-700",
    buttonText: "text-orange-800 dark:text-orange-200",
    buttonHover: "hover:bg-orange-300 dark:hover:bg-orange-600",
  },
};

export function DebugBox({ title, color, children, defaultOpen = false }: DebugBoxProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const colors = colorClasses[color];

  return (
    <div className={`${colors.bg} border-2 ${colors.border} rounded-lg p-4`}>
      <div className="flex justify-between items-center mb-3">
        <h4 className={`font-bold ${colors.titleText}`}>🔧 DEBUG: {title}</h4>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`px-3 py-1 ${colors.buttonBg} ${colors.buttonText} rounded-md ${colors.buttonHover} transition-colors text-sm font-subheader`}
        >
          {isOpen ? 'Hide' : 'Show'}
        </button>
      </div>
      
      {isOpen && children}
    </div>
  );
}
